import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';
import AccionaBigButton from '../../../../../components/AccionaBigButton';
import { getDocumentsByProjectId } from '../../../../../services/api/project';

const Home = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { id } = useParams();
  const [pendingDocuments, setPendingDocuments] = useState({
    scannedDocumentsPC: 0,
    scannedDocumentsRC: 0,
  });

  useEffect(() => {
    getDocumentsByProjectId(id).then((response) => {
      setPendingDocuments({
        scannedDocumentsPC: response.scannedDocumentsPC || 0,
        scannedDocumentsRC: response.scannedDocuments || 0,
      });
    });
  }, [id]);

  return (
    <div className="row">
      <div className="col-xs-12 col-sm-6 col-md-6">
        <AccionaBigButton
          pendingDocs={pendingDocuments.scannedDocumentsRC}
          icon="docs-ok"
          id="scannedDocumentsRC"
          onClick={() => navigate('scannedDocumentsRC/validated')}
          msg={intl.formatMessage({
            id: `pages.quality.ocr.scannedDocuments.scannedDocumentsRC`,
          })}
        />
      </div>
      <div className="col-xs-12 col-sm-6 col-md-6">
        <AccionaBigButton
          pendingDocs={pendingDocuments.scannedDocumentsPC}
          icon="docs-ok"
          id="scannedDocumentsPC"
          onClick={() => navigate('scannedDocumentsPC/validated')}
          msg={intl.formatMessage({
            id: `pages.quality.ocr.scannedDocuments.scannedDocumentsPC`,
          })}
        />
      </div>
    </div>
  );
};

export default Home;
